// @flow
export const DININGROOM: 'diningroom' = 'diningroom';
export const PASSING: 'passing' = 'passing';
export const LOCKERS: 'lockers' = 'lockers';
export const VENDING: 'vending' = 'vending';
export const TRANSPORT: 'transport' = 'transport';
export const INTERCOM: 'intercom' = 'intercom';
